import styled from 'styled-components'

export const Expanded = styled.div`
  flex-grow: 1;
`
